import { Col, Row } from 'antd';
import Modal, { ModalProps } from 'antd/lib/modal/Modal';
import React, { ReactElement } from 'react';

const DefaultModal: React.FC<{ props: ModalProps; children: ReactElement }> = ({ children, props }) => (
  <Modal
    // maskClosable={false}
    centered
    footer={null}
    style={{
      maxHeight: '100%',
    }}
    bodyStyle={{
      padding: '16px',
      maxHeight: '98vh',
      overflow: 'auto',
      // eslint-disable-next-line react/destructuring-assignment
      ...props.bodyStyle,
    }}
    {...props}>
    <Row align='middle' justify='center'>
      <Col span={24}>{children}</Col>
    </Row>
  </Modal>
);

export default React.memo(DefaultModal);
